import React, { Component } from 'react'
import { Modal, Button, FormGroup, ControlLabel, FormControl, HelpBlock, Alert } from 'react-bootstrap'
import { cloneDeep } from 'lodash'

const FieldGroup = ({ id, validationState, label, help, ...props }) => (
    <FormGroup controlId={id} validationState={!props.value ? 'error' : null}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...props} />
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
)

export default class IpRangeModal extends Component {

  constructor() {
    super()
    this.state = { show: false, location: {}, modalTitle: '', errorMessage: '' }
  }

  add(group) {
    let location = {}
    location.group = group
    this.setState({location, show: true, modalTitle: 'IP-Range toevoegen'})
  }

  edit(location) {
    this.setState({location: cloneDeep(location), show: true, modalTitle: 'IP-Range bewerken'})
  }

  onChange(property, value) {
    let location = this.state.location
    location[property] = value
    this.setState({location})
  }

  close() {
    this.setState({ show: false, location: {}, errorMessage: '' })
  }

  isValid() {
    const location = this.state.location
    return location.name && location.ipAddressFrom && location.ipAddressTo
  }

  onSave() {
    if (this.isValid()) {
      this.props.onSave(this.state.location)
        .then(() => {
          this.close()
          this.props.reload()
        })
        .catch((error) => this.setState({errorMessage: this.getErrorMessage(error.response.data)}) )
    }
  }

  getErrorMessage(type) {
    const lines = type.split('\n')
    switch (lines[0]) {
      case 'invalidIp': return 'IP-Range kan niet worden opgeslagen: invalide ip adres'
      case 'overlappingIp': return `IP-Range kan niet worden opgeslagen, overlappend ip adres met groep: ${lines[1]}, IP-range: ${lines[2]}`
      case 'fromGreaterThanTo': return 'IP-Range kan niet worden opgeslagen: Van is groter dan Tot'
      default: return 'Fout bij opslaan'
    }
  }

  render() {
    const { show, modalTitle, location, errorMessage } = this.state
    return (
      <div>
        <Modal show={ show } onHide={ () => this.close() }>
          <Modal.Header>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            { errorMessage && <Alert bsStyle='danger'>{errorMessage}</Alert>}
            <FieldGroup 
              type='text' 
              label='Naam' 
              value={location.name} 
              onChange={(e) => this.onChange('name', e.target.value)} 
            />
            <FieldGroup 
              type='text' 
              label='Van' 
              placeholder='IPv4 of IPv6' 
              value={location.ipAddressFrom} 
              onChange={(e) => this.onChange('ipAddressFrom', e.target.value)} 
            />
            <FieldGroup 
              type='text' 
              label='Tot' 
              placeholder='IPv4 of IPv6' 
              value={location.ipAddressTo} 
              onChange={(e) => this.onChange('ipAddressTo', e.target.value)} 
            />
          </Modal.Body>

          <Modal.Footer>
            <Button 
              bsStyle='danger' 
              onClick={ () => this.close() } 
              id='cancel'>Annuleren
            </Button>
            <Button 
              bsStyle='success' 
              onClick={ () => this.onSave() } 
              disabled={!this.isValid()} 
              id='confirm'>Opslaan
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}
